import { render, staticRenderFns } from "./Konzessionsabgaben.vue?vue&type=template&id=121b7cb0&scoped=true&"
import script from "./Konzessionsabgaben.vue?vue&type=script&lang=js&"
export * from "./Konzessionsabgaben.vue?vue&type=script&lang=js&"
import style0 from "./Konzessionsabgaben.vue?vue&type=style&index=0&id=121b7cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121b7cb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VImg,VRow,VSelect,VSheet,VTooltip})
